import React from 'react';
import { StyleSheet } from 'react-native';

import { Box } from '@components/Restyle';

type OverlayProps = {
  visible: boolean;
  children?: React.ReactNode;
  backgroundColor?: string;
};

const Overlay = ({
  visible,
  children,

  backgroundColor = undefined,
}: OverlayProps) => {
  if (!visible) return null;

  return (
    <Box style={styles.container} pointerEvents='auto' zIndex={9999}>
      <Box
        style={
          backgroundColor
            ? [{ ...styles.overlay, backgroundColor }]
            : styles.overlay
        }
        pointerEvents='auto'
      />
      <Box style={styles.childrenContainer} pointerEvents='box-none'>
        {children}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  overlay: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  childrenContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Overlay;
